import React, {useEffect, useMemo, useRef} from "react";
import {EditorContent, EditorContext, useEditor} from "@tiptap/react";
import {StarterKit} from "@tiptap/starter-kit";
import {TextAlign} from "@tiptap/extension-text-align";
import {Underline} from "@tiptap/extension-underline";
import {Typography} from "@tiptap/extension-typography";
import RichTextToolbar from "../../requests/components/RichTextToolbar";
import RichTextLinkExtension from "../../requests/components/RichTextLinkExtension";

const RichDescriptionEditor = ({value, onChange, className = "", contentClassName = "", readOnly = false}) => {
    const valueRef = useRef(value);
    const readOnlyRef = useRef(readOnly);
    valueRef.current = value;
    readOnlyRef.current = readOnly;
    const editor = useEditor({
        immediatelyRender: false,
        editorProps: {
            attributes: {autocomplete: "off", autocorrect: "off", autocapitalize: "off"},
        },
        extensions: [
            StarterKit,
            TextAlign.configure({types: ["heading", "paragraph"]}),
            Underline,
            Typography,
            RichTextLinkExtension
        ],
        content: value || "",
        editable: !readOnly,
        onBlur: ({editor: currentEditor}) => {
            if (readOnlyRef.current) return;
            const content = currentEditor.getHTML();
            if (content !== (valueRef.current || "")) onChange(content);
        },
    });
    useEffect(() => {
        if (!editor) return;
        editor.setEditable(!readOnly);
        const nextContent = value || "";
        if (editor.getHTML() !== nextContent) editor.commands.setContent(nextContent, {emitUpdate: false});
    }, [editor, readOnly, value]);
    const providerValue = useMemo(() => ({editor}), [editor]);

    return (
        <EditorContext.Provider value={providerValue}>
            <div className={`text-editor ${className}`}>
                {!readOnly && <RichTextToolbar />}
                <div className={`content-wrapper ${contentClassName}`}>
                    <EditorContent editor={editor} className="editor-content" />
                </div>
            </div>
        </EditorContext.Provider>
    );
};

export default RichDescriptionEditor;
